import DirectionUIModel from 'domain/ui/models/DirectionUIModel';
import IngredientUIModel from 'domain/ui/models/IngredientUIModel';

const mapUIModelToDataModel = (recipeContent) => ({
  ...recipeContent,
  ingredients: recipeContent.ingredients.map(
    (ingredient) => ingredient.ingredientText
  ),
  directions: recipeContent.directions.map(
    (direction) => direction.directionText
  ),
});

const mapDataModelToUIModel = (recipeContent) => {
  const ingredients = recipeContent.ingredients || [];
  const directions = recipeContent.directions || [];

  return {
    ...recipeContent,
    ingredients: ingredients.map(
      (ingredientText) => new IngredientUIModel(ingredientText)
    ),
    directions: directions.map(
      (directionText) => new DirectionUIModel(directionText)
    ),
  };
};

const mapUIModelToString = (recipeContent) => {
  return JSON.stringify(recipeContent);
};

const mapStringToUIModel = (recipeContent) => {
  return JSON.parse(recipeContent);
};

const RecipeContentMapper = {
  mapUIModelToDataModel,
  mapDataModelToUIModel,
  mapUIModelToString,
  mapStringToUIModel,
};

export default RecipeContentMapper;
